import React from 'react';
import { ChevronDown } from 'lucide-react';

const SidebarItem = ({
  icon: Icon,
  label,
  isActive = false,
  onClick,
  hasSubItems = false,
  isExpanded = false,
  onToggle,
  badge,
  isCollapsed = false,
  disabled = false,
  level = 0,
  className = ''
}) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (disabled) return;

    if (hasSubItems && onToggle) {
      onToggle();
    } else if (onClick) {
      onClick();
    }
  };

  const isSubItem = level > 0;
  const itemHeight = isSubItem ? (level >= 2 ? 'h-[36px]' : 'h-[38px]') : 'h-[42px]';
  const fontSize = isSubItem ? (level >= 2 ? 'text-[13.5px]' : 'text-[14px]') : 'text-[15px]';
  const iconSize = isSubItem ? (level >= 2 ? 'h-[16px] w-[16px]' : 'h-[17px] w-[17px]') : 'h-[19px] w-[19px]';

  return (
    <div
      onClick={handleClick}
      title={isCollapsed ? label : undefined}
      className={`sidebar-item relative flex items-center justify-between w-full ${itemHeight} px-2.5 rounded-[8px] cursor-pointer transition-all duration-150 ease-in-out select-none group ${
        isActive
          ? 'bg-[#0F2942] text-white font-semibold shadow-xs'
          : 'text-[#334155] hover:bg-[#F1F5F9] hover:text-[#0F2942] font-medium'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${
        isCollapsed ? 'justify-center px-0' : 'gap-2'
      } ${className}`}
      data-active={isActive}
    >
      <div className={`flex items-center min-w-0 ${isCollapsed ? 'justify-center w-full' : 'flex-1'}`}>
        {Icon && (
          <Icon
            className={`${iconSize} flex-shrink-0 stroke-[2] transition-colors duration-150 ${
              isActive ? 'text-white' : 'text-[#64748B] group-hover:text-[#0F2942]'
            } ${isCollapsed ? '' : 'mr-2.5'}`}
          />
        )}
        {!isCollapsed && (
          <span
            className={`${fontSize} truncate ${
              isActive ? 'text-white font-semibold' : 'text-[#334155] group-hover:text-[#0F2942]'
            }`}
          >
            {label}
          </span>
        )}
        {!isCollapsed && badge !== null && badge !== undefined && (
          <span className="ml-auto px-2 py-0.5 text-[11px] font-semibold bg-[#DBEAFE] text-[#0F2942] rounded-full">
            {badge}
          </span>
        )}
      </div>

      {!isCollapsed && hasSubItems && (
        <ChevronDown
          className={`h-4.5 w-4.5 flex-shrink-0 stroke-[2] transition-transform duration-200 ease-in-out ml-1 ${
            isActive ? 'text-white' : 'text-[#64748B] group-hover:text-[#0F2942]'
          } ${isExpanded ? 'rotate-180' : ''}`}
        />
      )}
    </div>
  );
};

export default SidebarItem;
